import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/** Hidden off-screen (not display:none) so naive bots still see and fill it. */
const OffScreenWrapper = styled.div`
  position: absolute;
  left: -9999px;
  top: 0;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

/**
 * Honeypot input for bot deterrence; the server rejects logins when filled.
 * aria-hidden and tabIndex=-1 keep it out of screen-reader and keyboard flows.
 * readOnly until focus blocks password-manager autofill (Chrome ignores
 * autocomplete="off"); JS-driven bots can still set the value.
 */
const HoneypotField = ({ field }) => {
  const [isReadOnly, setIsReadOnly] = useState(true);

  return (
    <OffScreenWrapper aria-hidden="true">
      <input
        {...field}
        id="contact_preference"
        type="text"
        tabIndex={-1}
        autoComplete="off"
        readOnly={isReadOnly}
        onFocus={() => setIsReadOnly(false)}
      />
    </OffScreenWrapper>
  );
};

HoneypotField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
  }),
};

export default HoneypotField;
